import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "appRedux/hooks"
import { updateCurrentItemComments } from "appRedux/slices/wishListSlice"
import { useLazyGetCommentsQuery, wishItemApi } from "appRedux/slices/wishItemApiSlice"

export default function useGetComments(id: number, show: boolean) {
  const currentItemComments = useAppSelector(state => state.wishList.currentItemComments)
  const cachedCurrentItemComments = useAppSelector((state) => id ? wishItemApi.endpoints.getComments.select(id)(state) : null)

  const [triggerGetComments, getCommentsResult] = useLazyGetCommentsQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!show) return
    if (cachedCurrentItemComments?.data) {
      dispatch(updateCurrentItemComments(cachedCurrentItemComments?.data || []))
      return
    }
    fetchComments()
  }, [id, show])

  function fetchComments() {
    triggerGetComments(id)
  }

  return {
    comments: currentItemComments?.comments || cachedCurrentItemComments?.data?.comments || getCommentsResult?.data?.comments || [],
    isFetching: getCommentsResult.isFetching,
    isError: getCommentsResult.isError
  }
}
